import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  AprimaCacheService,
} from 'webcommon/legacy-common';
import {
  AttachmentTypeDto,
  ClinicalNoteTypeDto,
  ConditionDto,
  FinancialCenterDto,
  GenericFilterDto,
  HistorianDto,
  Lists_AppointmentStatusDto,
  MessageTypeDto,
  ProviderDto,
  RxWorkflowStatusDto,
  ServiceSiteDto,
  TimeFrameDto,
  TimespanDto,
  UserGroupUserDto,
  VisitFormattingModelDto,
} from 'webcommon/shared';
import {
  ListRepository,
} from 'webcommon/webapi';

@Injectable({
providedIn: 'root',
})
export class ListService {
  constructor(
    private aprimaCacheService: AprimaCacheService,
    private listRepository: ListRepository,
  ) { }

  private getList(listName: string, params?: any): Observable<any> {
    const cache = this.aprimaCacheService.get('Lists');
    return this.listRepository.getList(listName, params, cache);
  }

  getActiveProblemFilterList(): Observable<GenericFilterDto[]> {
    return this.getList('activeproblemfilter');
  }

  getActiveTimespans(): Observable<TimespanDto[]> {
    return this.getList('activetimespan');
  }

  getAppointmentStatusList(): Observable<Lists_AppointmentStatusDto[]> {
    return this.getList('appointmentstatus');
  }

  getAttachmentTypes(): Observable<AttachmentTypeDto[]> {
    return this.getList('attachmenttypes');
  }

  getClinicalNoteTypes(providerId: string): Observable<ClinicalNoteTypeDto[]> {
    return this.getList('clinicalnotetypes', {
      providerId,
    });
  }

  getConditions(): Observable<ConditionDto[]> {
    return this.getList('patientconditions');
  }

  getFinancialCenters(): Observable<FinancialCenterDto[]> {
    return this.getList('financialcenter');
  }

  getHistorians(): Observable<HistorianDto[]> {
    return this.getList('historians');
  }

  getMessageTypes(): Observable<MessageTypeDto[]> {
    return this.getList('messagetypes');
  }

  getProviders(): Observable<ProviderDto[]> {
    return this.getList('provider');
  }

  getRxWorkflowStatusList(): Observable<RxWorkflowStatusDto[]> {
    return this.getList('rxworkflowstatus');
  }

  getServiceSites(): Observable<ServiceSiteDto[]> {
    return this.getList('servicesite');
  }

  getTimeFrames(): Observable<TimeFrameDto[]> {
    return this.getList('timeframes');
  }

  getUserGroupUsers(): Observable<UserGroupUserDto[]> {
    return this.getList('users');
  }

  getVisitFormattingModels(): Observable<VisitFormattingModelDto[]> {
    return this.getList('visitformattingmodels');
  }
}
